import { ClipboardList } from 'lucide-react';

export function EmptyStateView() {
  return (
    <div className='flex flex-col items-center justify-start pt-12 h-full bg-white'>
      <ClipboardList className='w-12 h-12 text-muted-foreground/60 mb-4' />
      <h3 className='text-lg font-medium'>Select an Optimisation</h3>
      <p className='text-sm text-muted-foreground'>Choose an optimisation from the left to view details</p>
    </div>
  );
}